<template>
  <button
    class="c-current-location-button"
    @click="handleClick"
  >
    <IconCircleArrow />
  </button>
</template>

<script setup lang="ts">
  import IconCircleArrow from '@/components/icons/IconCircleArrow.vue';

  const emit = defineEmits<{
    (e: 'click'): void;
  }>();

  function handleClick() {
    emit('click');
  }
</script>

<style>
  .c-current-location-button {
    background-color: transparent;
    outline: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;

    svg {
      width: 74px;
      height: 74px;
    }

    &:hover {
      opacity: 0.8;
    }
  }
</style>
